module.exports = __webpack_public_path__ + "static/media/taco.0b48130f.svg";